import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { fileUrl } from "@/lib/api";
import Placeholder from "@/components/Placeholder";

export default function Lightbox({ item, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <AnimatePresence>
      {item && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-6"
          onClick={onClose}
          data-testid="lightbox-overlay"
          role="dialog"
          aria-modal="true"
          aria-label={item.alt || "Image viewer"}
        >
          <button
            onClick={onClose}
            data-testid="lightbox-close-button"
            aria-label="Close"
            className="absolute top-6 right-6 text-white/80 hover:text-white p-2"
          >
            <X size={28} />
          </button>
          <motion.div
            initial={{ scale: 0.94, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="max-w-5xl w-full max-h-[85vh]"
            onClick={(e) => e.stopPropagation()}
          >
            {item.src ? (
              <img
                src={fileUrl(item.src)}
                alt={item.alt || ""}
                className="w-full h-full max-h-[85vh] object-contain"
              />
            ) : (
              <Placeholder label={item.alt || "Gallery image"} className="w-full aspect-video" />
            )}
            {item.alt && (
              <p className="mt-4 text-center text-sm text-white/60 font-mono">{item.alt}</p>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
